
import FastagMainComp from "../../components/fastag/FastagMainComp"

export const FastTagReportsPages = ({ title_1, title_2, title }) => {
   
    return <div>
        <FastagMainComp title_1={title_1} title_2={title_2} title={title} />
    </div>
}